import store from "../store";
import * as actions from "../actions";
import React from "preact";

interface AsideTextObjectNavProps {
  view: string;
  isMobileVersion: boolean;
}

const { dispatch } = store;
const { goToView, goToSubview, setSelectionType } = actions;

export default function AsideTextObjectNav({view, isMobileVersion}: AsideTextObjectNavProps) {
  function goTo(view: string) {
    dispatch(goToView(view));
    if (view === 'text-mo') {
      dispatch(goToSubview('add-new'));
    } else if (view === 'text-plain') {
      dispatch(goToSubview('plain'));
    }
  }

  return <header id="app-aside-menu-object-nav">
    <nav className="main menu-object-nav">
      <ul>
        <li><a className={`link ${view.indexOf('text-mo') > -1 ? ' active' : ''}`} onClick={() => goTo('text-mo')}>Menu Items</a></li>
        <li><a className={`link ${view === 'text-plain' ? ' active' : ''}`} onClick={() => goTo('text-plain')}>Plain Text</a></li>
      </ul>
    </nav>
  </header>

}
